import styled from 'styled-components'
import Row from 'reactstrap/lib/Row'
import { SIZES } from '../../../constants'

export default styled(Row)`
  justify-content: space-between;
  margin: 0;
  display: -ms-flexbox;
  -ms-flex-wrap: wrap;
  -ms-flex-pack: space-between;
  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    flex-wrap: nowrap;
    -ms-flex-wrap: none;
  }
  @media screen and (max-width: 800px) and (-ms-high-contrast: active), screen and (max-width: 800px) and (-ms-high-contrast: none) {
    width: 100% !important;
    display: block !important;
  }
`
